// extracted by mini-css-extract-plugin
export default {"backdrop":"backdrop_backdrop__abJnC","backdropClosing":"backdrop_backdropClosing__l56an"};